import React from 'react';
import { Hero } from './components/Hero';
import { ContextSection } from './components/ContextSection';
import { RoleEvolution } from './components/RoleEvolution';
import { Tensions } from './components/Tensions';
import { Approach } from './components/Approach';
import { Stakeholders } from './components/Stakeholders';
import { Collaborators } from './components/Collaborators';
import { Outcomes } from './components/Outcomes';
import { Range } from './components/Range';
import { Reflections } from './components/Reflections';
import { Testimonials } from './components/Testimonials';
import { SignOff } from './components/SignOff';
export function App() {
  return <main className="w-full min-w-[1200px] bg-ink font-sans text-ink antialiased" data-id="element-0" data-mp="31cjnnz899l0u">
      <Hero data-id="element-1" data-mp="2wip6p3k1bk5g" />
      <ContextSection data-id="element-2" data-mp="2wi5nzkmk8rqd" />
      <RoleEvolution data-id="element-3" data-mp="28u5z6q8t7bef" />
      <Tensions data-id="element-4" data-mp="28te0v7ntuzkg" />
      <Approach data-id="element-5" data-mp="28suumo7jhzm9" />
      <Stakeholders data-id="element-6" data-mp="28sl0cofgp6ar" />
      <Collaborators data-id="element-7" data-mp="23vcjqs9ypabm" />
      <Outcomes data-id="element-8" data-mp="23vuoyeelqyvo" />
      <Range data-id="element-9" data-mp="23u9v6r043jyv" />
      <Reflections data-id="element-10" data-mp="23utcq6luo6cd" />
      <Testimonials data-id="element-11" data-mp="23t8iki3g6pf1" />
      <SignOff data-id="element-12" data-mp="3ijxokogyjwiu" />
    </main>;
}